module.exports = __webpack_public_path__ + "media/images/silvets_300x250-16d8f25691f7f5d18b19d09da807fdda.jpg";